export default __webpack_public_path__ + "static/media/cartão_identificado_frente.ccdd69ad.png";